<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'dollar-sign']"></fa-icon>
				</span>
				<span class="overview-title">Open Balance</span>
			</div>

			<div class="p-grid overview-detail">
				<div class="p-col-12">
					<div class="overview-number">
						{{ openBalance | currency }}
					</div>
					<div class="overview-subtext">as of {{ app.moment().format("l LT") }}</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="card no-gutter widget-overview-box widget-overview-box-2">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'calendar-day']"></fa-icon>
				</span>
				<span class="overview-title">Billed this month</span>
			</div>

			<div class="p-grid overview-detail">
				<div class="p-col-12">
					<div class="overview-number">
						{{ billedThisMonth | currency }}
					</div>
					<div class="overview-subtext">as of {{ app.moment().format("l LT") }}</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-invoice-list [(invoice)]="invoice"></app-invoice-list>

<app-invoice-record *ngIf="invoice" [(invoice)]="invoice"></app-invoice-record>
